import { RequestResetPasswordForm } from './components/request-reset-password-form';
import { Schema } from './components/request-reset-password-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useRequestPasswordResetMutation } from '../mutations';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';

export function Page() {
  const mutation = useRequestPasswordResetMutation();
  const navigate = useNavigate();

  async function handleSubmit(payload: Schema) {
    await mutation.mutateAsync({
      url: `${window.location.origin}/auth/reset-password/confirm/`,
      ...payload,
    });

    navigate('/auth/reset-password/request/success');
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Återställ lösenord" />
      <RequestResetPasswordForm isLoading={mutation.isPending} onSubmit={handleSubmit} />
    </Fragment>
  );
}
